import { IRequestFetcherOptions, IParamsOption } from "src/common/razzle-platform-components/types"
import { fetchCategoryOfProduct, fetchCategoriesOfProduct } from "src/common/razzle-platform-categoryofproduct/effects"
import { Store } from 'src/redux'

// we fixed this CATEGORY_OF_PRODUCT_PROPS_ID for use it to save our props in reudcer
export const CATEGORY_OF_PRODUCT_PROPS_ID = 'categoryOfProductProps'

// we use this function to get the category of product on the server side
export async function getInitialPropsOfCategoryOfProduct({ route }, store: Store, options: Pick<IParamsOption, 'params'> = {}) {
    try {
        const { id } = route.params;
        const { dispatch, getState } = store

        // in category of product we need params for make forced request exmaple: parms: { _embed: [user, ...etc]}
		const queryOptions: Pick<IRequestFetcherOptions, 'params'> = {
			params: options.params,
		}

        // get the locale
		const locale: string = getState().translationModel.locale

		// set the Accept-Language to the headers of the request for get the translated data
		const headers = { "Accept-Language": locale }

		// get the category of product by execute the effect fetchCategoryOfProduct and pass it queryOptions
		const { categoryOfProduct } = await fetchCategoryOfProduct(id, queryOptions, headers)

        // save the initialProps in the reducer
		dispatch.ssrModel.setInitialProps({ [CATEGORY_OF_PRODUCT_PROPS_ID]: { categoryOfProduct, queryOptions } })

    } catch (error) {
        console.log('mmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmm', error)
    }
}


// we fixed this CATEGORIES_OF_PRODUCT_PROPS_ID for use it to save our props in reudcer
export const CATEGORIES_OF_PRODUCT_PROPS_ID = 'categoriesOfProductProps'

// we use this function to get the categories of product on the server side
export async function getInitialPropsOfCategoriesOfProduct({ route }, store: Store, options: IParamsOption={ params: null, useUrlParams: true, usePagination: true }) {
	try {

        const { dispatch, getState } = store

        const queryOptions: IRequestFetcherOptions = {
            // prams given from url
            searchParams: route.query,
            // forced params by user not it's shown in url
            params: options.params,
            // to allow use pagination
            usePagination: options.usePagination,
            // to allow use search parms from url
            useUrlParams: options.useUrlParams
        }

        // get the locale
		const locale: string = getState().translationModel.locale

		// set the Accept-Language to the headers of the request for get the translated data
		const headers = { "Accept-Language": locale }

        // get the categories of product by execute the effect fetchCategoriesOfProduct and pass it queryOptions
        const { categoriesOfProduct, pagination } = await fetchCategoriesOfProduct(queryOptions, headers)

        // save the initialProps in the reducer
        dispatch.ssrModel.setInitialProps({ [CATEGORIES_OF_PRODUCT_PROPS_ID]: { categoriesOfProduct, pagination, queryOptions } })

	} catch (error) {
        console.log('errrrorrrr', error)
	}
}